import { __ } from '@wordpress/i18n';
import { Badge } from '@getdokan/dokan-ui';
import { QUOTE_STATUS, STATUS_LABELS } from '../../constants';
import { DokanBadge } from '@dokan/components';

interface QuoteStatusProps {
    status: keyof typeof QUOTE_STATUS;
}

const QuoteStatus: React.FC< QuoteStatusProps > = ( { status } ) => {
    const getStatusColor = ( status: keyof typeof QUOTE_STATUS ): string => {
        const colors = {
            [ QUOTE_STATUS.PENDING ]: 'bg-[#fee8c9] text-[#9d5425]',
            [ QUOTE_STATUS.UPDATED ]: 'bg-[#cef1ff] text-[#0B76B7]',
            [ QUOTE_STATUS.APPROVE ]: 'text-[#E9F9FF] bg-[#0B76B7]',
            [ QUOTE_STATUS.REJECT ]: 'bg-[#ffe1e1] text-[#bc1c21]',
            [ QUOTE_STATUS.CONVERTED ]: 'bg-[#cdf7de] text-[#004434]',
            [ QUOTE_STATUS.ACCEPTED ]: 'text-[#daf8e6] bg-[#004434]',
            [ QUOTE_STATUS.EXPIRED ]: 'text-[#fffbeb] bg-[#9d5425]',
            [ QUOTE_STATUS.CANCEL ]: 'text-[#fef3f3] bg-[#bc1c21]',
            [ QUOTE_STATUS.TRASH ]: 'text-[#333333] bg-[#ededed]',
        };

        return colors[ status ] || colors[ QUOTE_STATUS.EXPIRED ];
    };

    const statusLabel = STATUS_LABELS[ status ] || status;

    // if ( status === 'pending' ) {
    //     return (
    //         <DokanBadge
    //             // variant="warning"
    //             label="Pending"
    //             className={ `min-w-[80px] text-center bg-[#fee8c9] text-[#9d5425]` }
    //         />
    //     );
    // }
    //
    // if ( status === 'updated' ) {
    //     return (
    //         <DokanBadge
    //             label="Updated"
    //             className={ `min-w-[80px] text-center bg-[#cef1ff] text-[#0B76B7]` }
    //         />
    //     );
    // }
    //
    // if ( status === 'reject' ) {
    //     return (
    //         <DokanBadge
    //             // variant="danger"
    //             label="Rejected"
    //             className={ `min-w-[80px] text-center bg-[#ffe1e1] text-[#bc1c21]` }
    //         />
    //     );
    // }
    //
    // if ( status === 'converted' ) {
    //     return (
    //         <DokanBadge
    //             // variant="success"
    //             label="Converted"
    //             className={ `bg-[#cdf7de] text-[#004434] min-w-[80px] text-center` }
    //         />
    //     );
    // }
    //
    // if ( status === 'approve' ) {
    //     return (
    //         <DokanBadge
    //             className={ `text-[#E9F9FF] bg-[#0B76B7] min-w-[80px] text-center` }
    //             label="Approved"
    //         />
    //     );
    // }
    //
    // if ( status === 'accepted' ) {
    //     return (
    //         <DokanBadge
    //             className={ `text-[#daf8e6] bg-[#004434] min-w-[80px] text-center` }
    //             label="Accepted"
    //         />
    //     );
    // }
    //
    // if ( status === 'expired' ) {
    //     return (
    //         <DokanBadge
    //             className={ `text-[#fffbeb] bg-[#9d5425] min-w-[80px] text-center` }
    //             label="Expired"
    //         />
    //     );
    // }
    //
    // if ( status === 'cancel' ) {
    //     return (
    //         <DokanBadge
    //             className={ `text-[#fef3f3] bg-[#bc1c21] min-w-[80px] text-center` }
    //             label="Cancelled"
    //         />
    //     );
    // }
    //
    // if ( status === 'trash' ) {
    //     return (
    //         <DokanBadge
    //             className={ `text-[#333333] bg-[#ededed] min-w-[80px] text-center` }
    //             label="Trash"
    //         />
    //     );
    // }

    return (
        <DokanBadge
            label={ statusLabel }
            color={ getStatusColor( status ) }
            className={ `min-w-[80px] text-center whitespace-normal capitalize font-semibold ${ getStatusColor(
                status
            ) }` }
        />
    );

    // return (
    //     <Badge
    //         label={ statusLabel }
    //         color={ getStatusColor( status ) }
    //         className={ `min-w-[80px] text-center whitespace-normal capitalize font-semibold ${ getStatusColor(
    //             status
    //         ) }` }
    //     />
    // );
};

export default QuoteStatus;
